import { render } from "./TheSidebar.vue?vue&type=template&id=95b52784&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./style.less?vue&type=style&index=0&id=95b52784&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b52784"]])

export default __exports__